import { BAR_Z_RANGE, color, size, testColors, type TestTone } from "@mesketch/design-tokens";

// Poloha na škále a ukazatel postupu (DES-003 §6). Škálu výsledku kreslí `PencilScale` (CR-014 §4).

/** Poloha z v procentech šířky pruhu, mimo rozsah oříznutá. */
export function barPosition(z: number): number {
  const p = ((z + BAR_Z_RANGE) / (2 * BAR_Z_RANGE)) * 100;
  return Math.round(Math.max(0, Math.min(100, p)) * 100) / 100;
}

/** Ukazatel postupu (DES-003 §6): podklad `progress-track`, výplň v barvě testu, výška 8 px. */
export function ProgressBar({ value, label, tone = "who" }: { value: number; label: string; tone?: TestTone }) {
  const p = Math.max(0, Math.min(1, value)) * 100;
  const h = size.progressHeight;
  return (
    <svg width="100%" height={h} role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(p)} style={{ display: "block" }}>
      <rect x="0" y="0" width="100%" height={h} rx={h / 2} fill={color.progressTrack} />
      {p > 0 ? <rect x="0" y="0" width={`${p}%`} height={h} rx={h / 2} fill={testColors[tone].strong} /> : null}
    </svg>
  );
}
